import React from 'react';
import { useTranslation } from 'react-i18next';
import { categoriesRef } from '../../firebase/collections';
import AdminLayout from '../../Components/Admin/AdminLayout';
import { useState, useEffect } from 'react';

function AdminCategories() {
  const { t } = useTranslation();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    categoriesRef()
      .get()
      .then((snap) => {
        setCategories(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      })
      .catch(() => setCategories([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout>
      <h1>{t('admin.categories')}</h1>
      {loading ? (
        <p>{t('admin.loading')}</p>
      ) : categories.length === 0 ? (
        <p>{t('admin.noCategories')}</p>
      ) : (
        <div className="adminTableWrap">
          <table className="adminTable">
            <thead>
              <tr>
                <th>{t('admin.id')}</th>
                <th>{t('admin.name')}</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((c) => (
                <tr key={c.id}>
                  <td>{c.id}</td>
                  <td>{c.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}

export default AdminCategories;
